import React, { PureComponent } from 'react';
import { Route, Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
// import { throttle } from 'underscore';
// import anime from 'animejs';

import Signature from './Signature';
import NavItemHeyo from './NavItemHeyo';
import NavItemPlay from './NavItemPlay';
import NavItemBits from './NavItemBits';
import throttle from '../throttle';

// The Nav creates links that can be used to navigate
// between routes.

// pure component renders only if state or props has changed. Good here because setting state on scroll
// https://60devs.com/pure-component-in-react.html
class Nav extends PureComponent {
  state = {
    fixedNav: '',
    // transitioning: '',
  };

  componentWillMount() {
  }

  componentDidMount() {
    this.rendered = true;
    window.addEventListener('scroll', () => this.handleScroll());

    if (document.fonts) {
      document.fonts.ready.then(() => {
        // alert(`MapleWeb loaded? ${document.fonts.check('1em MapleWeb')}`); // true
        // alert(`apercu loaded? ${document.fonts.check('1em apercu')}`); // true
        document.documentElement.classList.add('fontsLoaded');
      });
    } else {
      // IE and Edge don't support document.fonts so just add the fontsLoaded class anyway
      document.documentElement.classList.add('fontsLoaded');
    }
  }


  // componentDidUpdate(prevProps) {
  //   if (this.props.location !== prevProps.location) {
  //     this.onRouteChanged();
  //   }
  // }

  componentWillUnmount() {
    window.removeEventListener('scroll', () => this.handleScroll());
  }

  // onRouteChanged() {
  //   this.setState({ transitioning: 'transitioning' });
  //   setTimeout(
  //     () => {
  //       this.setState({ transitioning: '' });
  //     },
  //     500); // time same as transitionEnterTimeout + transitionLeaveTimeout
  // }

  handleScroll = throttle( // https://stackoverflow.com/questions/23123138/perform-debounce-in-react-js/28046731#28046731
    () => {
      // console.log('throttle');
      if (window.pageYOffset > 50) {
        this.setState({ fixedNav: 'fixed-nav--scroll' });
      } else {
        this.setState({ fixedNav: '' });
      }
    }, 100,
  );


  render() {
    return (
      <nav className="nav">
        {/* <nav className={`nav ${this.state.transitioning}`}> */}
        <div className={`fixed-nav ${this.state.fixedNav}`}>
          <div className="fixed-nav__inner">

            <Link to={`/${this.props.location.pathname.startsWith('/bits/') ? 'bits/' : ''}`} className="back-button">
              <svg className="back-button__svg" viewBox="0 0 11 19">
                <polygon points="10.339 18.678 1 9.339 10.339 0" />
              </svg>
            </Link>

            <Route component={Signature} />

          </div>
        </div>
        <div className="nav__list-wrapper">
          <ul className="nav__list">

            <li className="nav__item">
              <Route component={NavItemHeyo} />
            </li>

            <li className="nav__item">
              <Route component={NavItemPlay} />
            </li>

            <li className="nav__item">
              <Route component={NavItemBits} />
            </li>

          </ul>
        </div>

      </nav>


    );
  }
}

Nav.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};


export default withRouter(Nav);



// WEBPACK FOOTER //
// ./src/components/Nav.js